<template>
  <div class="d-flex flex-row">
    <div class="d-flex mr-3">
      <el-image
        :src="displayImageUrl"
        :fit="'cover'"
        :preview-src-list="[displayImageUrl]"
        style="width: 271px; height:150px;"
      >
        <div slot="error" class="image-slot">
          <img src="/image/static/img/nopic.jpg" />
        </div>
      </el-image>
    </div>
    <div class="context-wrapper flex-grow-1">
      <div class="context">
        <div class="context-item d-flex align-items-end">
          <div class="mr-4">ITEM NO.</div>
          <div style="font-weight: bold;">{{ productInfo.proposalStyleNo }}</div>
        </div>
      </div>
      <div class="context">
        <div class="context-item">
          <div class="context-item__label" v-if="productInfo.brandName">
            {{ productInfo.brandName }}
          </div>
          <div
            v-if="productInfo.sampleNameEn"
            class="context-item__value"
            style="color:#101010"
          >
            {{ productInfo.sampleNameEn }}
          </div>
        </div>
        <div class="context-item" v-if="productInfo.sampleSize">
          <div class="context-item__label">
            {{ 'SIZE' }}
          </div>
          <div class="context-item__value">
            {{ productInfo.sampleSize }}
            {{ productInfo.sampleSizeUnit }}
          </div>
        </div>
      </div>
      <div class="context">
        <div class="context-item">
          <div class="context-item__value">
            <p>{{ productInfo.sampleContent }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { devTrackingCode: { type: String, default: '' } },
  data() {
    return {
      productInfo: {},
    }
  },
  computed: {
    displayImageUrl() {
      const { defaultImageUrl } = this.productInfo
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.devTrackingCode) return
      const res = await this.$api
        .masterCustomerDevTrackingDetailApi({
          devTrackingCode: this.devTrackingCode,
        })
        .catch(() => null)
      this.productInfo = res?.body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
.context-wrapper {
  .context {
    border-bottom: 1px solid #efefef;
    padding: 8px 0;
    .context-item {
      margin-bottom: 15px;
      font-size: 16px;
    }
    .context-item:last-child {
      margin-bottom: 0;
    }
    .context-item .context-item__label {
      color: #101010;
      margin-bottom: 8px;
      font-weight: 600;
    }
    .context-item .context-item__label:empty {
      display: none;
    }
    .context-item .context-item__value {
      color: #4f4f4f;
      line-height: 20px;
      white-space: pre-line;
      word-wrap: break-word;
      word-break: break-all;
    }
    .context-item .context-item__value:empty {
      display: none;
    }
    .context-item .context-item__value p {
      margin-bottom: 6px;
    }
    .context-item .context-item__value p:last-child {
      margin-bottom: 0;
    }
    .context-item .context-item__value.price {
      display: flex;
      justify-content: space-between;
      .quotedPrice {
        color: rgba(40, 167, 69, 1);
        font-size: 20px;
        margin-right: 6px;
      }
    }
    .context-item .context-item__value.features {
      display: flex;
      flex-wrap: wrap;
      .el-image {
        width: calc(calc(100% / 5) - calc(10px * 4 / 5));
        margin-right: 10px;
        margin-top: 10px;
      }
      .el-image:nth-child(-n + 5) {
        margin-top: 0;
      }
      .el-image:nth-child(5n + 5) {
        margin-right: 0;
      }
    }
  }
  .context:first-child {
    padding-top: 0;
  }
  .context:last-child {
    border-bottom: none;
  }
  .context.show-more {
    padding-bottom: 0;
    .context-item {
      margin-bottom: 0;
    }
    .show_more-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      span {
        color: rgba(142, 142, 142, 1);
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}
</style>
